const projeto = process.env.REACT_APP_PROJETO;

interface SystemText {
    programa: string;
    color1: string;
    color2: string;
    bandeira: string;
    backgroudBanner: string;
}

interface Projetos {
    farmapontos: SystemText;
    totalcash: SystemText;
}

const system_vars: Projetos = {
    farmapontos: {
        programa: "farmapontos",
        color1: "#0A5888",
        color2: "#009D57",
        bandeira: "da sua farmacia",
        backgroudBanner: "#cadace",
    },
    totalcash: {
        programa: "totalcash",
        color1: "#e30f0e",
        color2: "#007edc",
        bandeira: "do grupo Total",
        backgroudBanner: "#aab6b9",
    }
}


export const _t: SystemText = {...system_vars[projeto]}

 